module.exports = __webpack_public_path__ + "img/primary-logo.f6ea3e6c.svg";